import { sendEvar } from '../../abt-utils/analytics'
import cookies from '../../abt-utils/cookies'
import eventManager from 'eventmanager'
import { warn } from '../../abt-utils/logger'

export function customCriteria (test) {
  var excluded = !!cookies.get(test.id + '_ex')

  if (excluded) {
    _trigger('excluded')
    warn('ABT: abt610 removed - customer excluded')
  }

  return excluded ? undefined : test
}

export function a (test) {
  var context = {
    recipe: 'a',
    test: test
  }

  return _init(context)
}

export function b (test) {
  var context = {
    recipe: 'b',
    test: test
  }

  return _init(context)
}

function _init (context) {
  return _hasOptOut()
    ? _excludeCustomer(context)
    : _exec(context)
}

function _hasOptOut () {
  return !!(eventManager._fired && eventManager._fired[_getEventName('optout')])
}

function _excludeCustomer (context) {
  _createOptOutCookie(context.test)
  warn('ABT: abt610 removed - customer excluded')
  return undefined
}

function _exec (context) {
  _trigger(context.recipe)
  sendEvar(context.test)
  return context.test
}

function _createOptOutCookie (test) {
  cookies.set(test.id + '_ex', 1, new Date(test.cookieExpiration))
}

function _trigger (eventSuffix) {
  eventManager.trigger(_getEventName(eventSuffix))
}

function _getEventName (eventSuffix) {
  return 'abtest:abt610:' + eventSuffix
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-tests/abt610/large.js
 ** module id = 63
 ** module chunks = 2
 **/